<template>
  <div class="fullTable">
    <v-row no-gutters class="flex-nowrap pb-2">
      <v-col class="fixedCol">
        <v-card
          class="pa-2 gridLocationText"
          tile
          outlined
          v-for="info of gridLocationInfo"
          :key="info.name"
        >
          {{ info.name }}
        </v-card>
      </v-col>
    </v-row>

    <div class="tableWrapper">
      <v-row no-gutters class="flex-nowrap pb-2">
        <v-col
          v-for="location in sortedLocationsByCity(locations)"
          :key="location.city"
        >
          <v-card class="pa-2" tile outlined :style="{ color: location.color, fontWeight: 'bold' }">
            <div class="gridLocationText">
              {{ location.city }}
            </div>
          </v-card>
          <v-card
            class="pa-2"
            tile
            outlined
            :style="{
              backgroundColor: location.color,
            }"
          >
            <span class="gridText" :style="{color: 'white', fontWeight: 'bold'}"> VVV </span>
          </v-card>
          <v-card
            class="pa-2"
            tile
            outlined
            v-bind:style="{
              background: '#FFFFCC',
            }"
          >
            <span class="gridText" :style="{color: location.color, fontWeight: 'bold' }"> VVV </span>
          </v-card>
          <v-card
            class="pa-2"
            tile
            outlined
            :style="{ backgroundColor: '#ffd320', color: location.color }"
          >
            <span class="gridText" :style="{color: location.color, fontWeight: 'bold' }"> VVV </span>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      sorting: -1,
      gridLocationInfo: [
        { name: "Villes" },
        { name: "Intervention" },
        { name: "Option" },
        { name: "Sur mesure" },
      ],
    };
  },
  computed: {
    ...mapGetters("locationModule", { locations: "getLocations" }),
  },
  methods: {
    sortedLocationsByCity(locations) {
      return locations
        .slice(0)
        .sort((a, b) => (a.city < b.city ? this.sorting : -this.sorting));
    },
  },
};
</script>

<style lang="scss">
.fullTable {
  display: flex;
  padding-bottom: 10px;
  text-align: center;

  .tableWrapper {
    overflow-x: scroll;
    overflow-y: hidden;

    .fixedCol {
      z-index: 2;
      left: 0;
      position: sticky;
      position: -webkit-sticky;
    }
    .gridText {
      color: black;
    }
    .gridLocationText {
      width: 125px;
      white-space: nowrap;
    }
  }
}
</style>
